var map = {
	"./en.23hbd.yml": "./common/locales/en.23hbd.yml",
	"./en.25hbd.yml": "./common/locales/en.25hbd.yml",
	"./en.yml": "./common/locales/en.yml",
	"./es.23hbd.yml": "./common/locales/es.23hbd.yml",
	"./es.25hbd.yml": "./common/locales/es.25hbd.yml",
	"./es.yml": "./common/locales/es.yml",
	"./fr.23hbd.yml": "./common/locales/fr.23hbd.yml",
	"./fr.25hbd.yml": "./common/locales/fr.25hbd.yml",
	"./fr.yml": "./common/locales/fr.yml",
	"./it.23hbd.yml": "./common/locales/it.23hbd.yml",
	"./it.25hbd.yml": "./common/locales/it.25hbd.yml",
	"./it.yml": "./common/locales/it.yml"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./common/locales sync \\.yml$";